import styles from "./InfoPage.module.scss"; // Імпортуємо SCSS файл для стилів
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
import CookiePopupButton from "@/components/CookieBanner/CookiePopupButton.tsx";
import { useEffect } from "react";

const FeedbackSuccess = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Скролимо в верх сторінки
  }, []);

  return (
    <div>
      <title>
        Feedback erfolgreich – HIXA – DSG Getriebe Reparatur & Wartung
      </title>
      <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      <Nav />
      <h2 className={`sectionContainer ${styles.title}`}>
        Feedback erfolgreich
      </h2>
      <div className="container sectionContainer sectionContainerWhite">
        <p className={styles.infoPageText}>
          Vielen Dank für Ihr Feedback! Unsere Manager werden sich in Kürze mit
          Ihnen in Verbindung setzen, um weitere Details zu klären.
          <br />
          Wir schätzen Ihre Rückmeldung und bemühen uns, Ihre Anfrage so schnell
          wie möglich zu bearbeiten.
        </p>

        <p className={styles.infoPageText}>
          Falls Sie noch Fragen haben, stehen wir Ihnen jederzeit zur Verfügung:
          <br />
          Telefon: +49 30 520 151 91
          <br />
          E-Mail: kunden@hixa.eu
        </p>
      </div>
      <CookiePopupButton />
      <Footer />
    </div>
  );
};

export default FeedbackSuccess;
